import { UNKNOWN_VERSION } from "src/app/constants"

export function hashString(str: string): string {
  let hash = 0
  if (str.length === 0) return hash.toString()
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i)
    hash = (hash << 5) - hash + char
    hash = hash & hash // Convert to 32bit integer
  }
  return hash.toString()
}

export function semverString(opts: {
  version: string | null
  build?: string | null
  preRelease?: string | null
  sha?: string | null
}) {
  if (!opts.version) return UNKNOWN_VERSION

  let semver = opts.version

  if (opts.preRelease) {
    semver += `-${opts.preRelease}`
  }

  if (opts.build) {
    semver += `+${opts.build}`
  }

  if (opts.sha) {
    semver += `.${opts.sha}`
  }

  return semver
}
